import { lazy } from 'react';
//培训计划
export const TrainingPlanRoutes = [
    {
        label: '',
        key: 'TrainingPlanLayout',
        path: '/training-plan',
        element: lazy(() => import('@/components/Layout/CommonLayout')),
        children: [
            {
                label: '详情',
                key: 'detail',
                show: false,
                path: 'detail/:id',
                element: lazy(() => import('@/page/TrainingPlan/detail'))
            },
            {
                label: '更多明细',
                key: 'moreDetail',
                show: false,
                path: 'moreDetail',
                element: lazy(() => import('@/page/MySpace/StudyArchives/components/trainingPlanDetail'))
            }
        ]
    }
];
